import React from 'react';
import PropTypes from 'prop-types';
import ErgoDataForm from '../../components/ErgoDataForm';
import { formTypes } from '../../models/form';

const HospitalLocation = props => <ErgoDataForm {...props} formType={formTypes.HOSPITAL} />;

HospitalLocation.propTypes = {
  localePath: PropTypes.string,
};

HospitalLocation.defaultProps = {
  localePath: '',
};

export { HospitalLocation as HospitalLocationPlain };
export default HospitalLocation;
